import {
    Checkbox, DetailsListLayoutMode, IColumn, IObjectWithKey, ISelection, SelectionMode,
} from '@fluentui/react';
import { useState } from 'react';
import { DetailsListDefault } from '../../../components/parts';
import { ICar } from '../../../utils/Car';

interface props {
    items: ICar[],
    selection?: ISelection<IObjectWithKey> | undefined,
    onItemInvoked?: () => void;
    enableShimmer?: boolean;
    isSortedAsc?: boolean;
    sortedField: string;
    setSorting: (isDesc: boolean, field: string) => void;
    loadMore?: boolean;
    lazyLoading?: boolean;
    loading?: boolean;
    loadMoreCallback?: () => void;
}

const CarsDetailsList = ({
    items,
    selection,
    onItemInvoked,
    enableShimmer = false,
    isSortedAsc = false,
    sortedField,
    setSorting, // = (isSortedAsc: boolean, sortedField: string) => {},
    loadMore,
    lazyLoading,
    loading,
    loadMoreCallback,
  }: props) => {
    // On Column Click
    const onColumnClick = (event: any, column: any) => {
        const sortedColumn = columns.filter((col: IColumn) => col.isSorted);
        let fieldName = '';
        let sortDescending = false;

        if (sortedColumn) {
          const newColumns = columns.map((col: IColumn) => {
            if (col.fieldName === column.fieldName) {
              col.isSorted = true;

              col.isSortedDescending =
                column.fieldName !== sortedColumn[0].fieldName
                  ? false
                  : !col.isSortedDescending;

              fieldName = column.fieldName;
              sortDescending = col.isSortedDescending;
            } else {
              col.isSorted = false;
            }
            return col;
          });

          setColumns(newColumns);
          setSorting(!sortDescending, fieldName);
        }
    };

    // Column List
    const columnsList = [
        {
          key: 'column1',
          name: 'Benaming',
          fieldName: 'name',
          minWidth: 250,
          maxWidth: 250,
          isRowHeader: true,
          onRender: (car: ICar) => <span>{car.name}</span>,
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column2',
          name: 'Type',
          fieldName: 'car_type',
          minWidth: 150,
          maxWidth: 150,
          isRowHeader: true,
          onRender: (car: ICar) => <span>{car.car_type}</span>,
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column3',
          name: 'Nummerplaat',
          fieldName: 'license_plate',
          minWidth: 120,
          maxWidth: 150,
          isRowHeader: true,
          onRender: (car: ICar) => <span>{car.license_plate}</span>,
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column4',
          name: 'Telefoon',
          fieldName: 'car_phone',
          minWidth: 80,
          maxWidth: 150,
          isRowHeader: true,
          onRender: (car: ICar) => <span>{car.car_phone}</span>,
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column5',
          name: 'Bestuurder',
          fieldName: 'driver_id',
          minWidth: 200,
          maxWidth: 200,
          isRowHeader: true,
          onRender: (car: ICar) =>
            car &&
            car.car_driver &&
            car.car_driver.length > 0 &&
            car.car_driver.map((car_driver: any) => {
              if (car_driver.current_driver) {
                return (
                  <span>{`${car_driver.employee.last_name} ${car_driver.employee.first_name}`}</span>
                );
              }
            }),
          data: 'string',
          isPadded: true,
        },
        {
          key: 'column6',
          name: 'In gebruik?',
          fieldName: 'active',
          minWidth: 75,
          maxWidth: 75,
          isRowHeader: true,
          onRender: (car: ICar) => (
            <span>
              <Checkbox disabled checked={!!car.active} />
            </span>
          ),
          onColumnClick,
          data: 'string',
          isPadded: true,
        },
    ];

    const initColumns = (sortedField: string, isSortedAsc: boolean) => columnsList.map((column: IColumn) => {
      if (column.fieldName === sortedField) {
        column.isSorted = true;
        column.isSortedDescending = !isSortedAsc;
        return column;
      }
      return column;
    });

    const [columns, setColumns] = useState(initColumns(sortedField, isSortedAsc));

    return (
      <DetailsListDefault
        items={items}
        columns={columns}
        layoutMode={DetailsListLayoutMode.justified}
        selection={selection}
        selectionMode={SelectionMode.single}
        selectionPreservedOnEmptyClick
        onItemInvoked={onItemInvoked}
        enableShimmer={enableShimmer}
        loadMore={loadMore}
        lazyLoading={lazyLoading}
        loadMoreCallback={loadMoreCallback}
        loading={loading}
      />
    );
  };

  export default CarsDetailsList;
